import { render } from "./Motivation.vue?vue&type=template&id=ffd615cc&scoped=true"
import script from "./Motivation.vue?vue&type=script&lang=js"
export * from "./Motivation.vue?vue&type=script&lang=js"

import "./Motivation.vue?vue&type=style&index=0&id=ffd615cc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/demo-webapp/demo-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffd615cc"]])

export default __exports__